import consentService from "services/consentService";
import { useDispatch, useSelector } from "react-redux";
import { setConsentModeValues } from "store/modules/global-common.slice";

// ############################################################

export const useConsentService = () => {
	const dispatch = useDispatch();

	const cookieConsentIsInitialized = useSelector(
		(state) => state.globalCommon.cookieConsent.isInitialized,
	);

	const consentValue = consentService.getConsentValue();
	const CONSENT_TYPES = consentService.CONSENT_TYPES;

	const grantFullConsent = () => {
		consentService.grantFullConsent();
		dispatch(
			setConsentModeValues({
				value: "all",
				isInitialized: true,
				settings: {
					[CONSENT_TYPES.ANALYTICS_STORAGE]: true,
					[CONSENT_TYPES.AD_STORAGE]: true,
					[CONSENT_TYPES.FUNCTIONALITY_STORAGE]: true,
					[CONSENT_TYPES.SECURITY_STORAGE]: true,
					[CONSENT_TYPES.AD_PERSONALIZATION]: true,
					[CONSENT_TYPES.AD_USER_DATA]: true,
				},
			}),
		);
	};

	const grantNecessaryConsent = () => {
		consentService.grantNecessaryConsent();
		dispatch(
			setConsentModeValues({
				value: "necessary",
				isInitialized: true,
				settings: {
					[CONSENT_TYPES.ANALYTICS_STORAGE]: false,
					[CONSENT_TYPES.AD_STORAGE]: false,
					[CONSENT_TYPES.FUNCTIONALITY_STORAGE]: true,
					[CONSENT_TYPES.SECURITY_STORAGE]: true,
					[CONSENT_TYPES.AD_PERSONALIZATION]: false,
					[CONSENT_TYPES.AD_USER_DATA]: false,
				},
			}),
		);
	};

	const grantCustomConsent = (settings) => {
		consentService.grantCustomConsent(settings);
		dispatch(
			setConsentModeValues({
				value: "custom",
				isInitialized: true,
				settings: {
					[CONSENT_TYPES.ANALYTICS_STORAGE]:
						settings.analytics_storage === "granted",
					[CONSENT_TYPES.AD_STORAGE]:
						settings.ad_storage === "granted",
					[CONSENT_TYPES.FUNCTIONALITY_STORAGE]:
						settings.functionality_storage === "granted",
					[CONSENT_TYPES.SECURITY_STORAGE]:
						settings.security_storage === "granted",
					[CONSENT_TYPES.AD_PERSONALIZATION]:
						settings.ad_personalization === "granted",
					[CONSENT_TYPES.AD_USER_DATA]:
						settings.ad_user_data === "granted",
				},
			}),
		);
	};

	const initializeConsent = () => {
		const consent = consentService.initializeConsent();

		if (!cookieConsentIsInitialized && consentValue && consent) {
			dispatch(
				setConsentModeValues({
					value: consentValue,
					isInitialized: true,
					settings: {
						[CONSENT_TYPES.ANALYTICS_STORAGE]:
							consent.analytics_storage === "granted",
						[CONSENT_TYPES.AD_STORAGE]:
							consent.ad_storage === "granted",
						[CONSENT_TYPES.FUNCTIONALITY_STORAGE]:
							consent.functionality_storage === "granted",
						[CONSENT_TYPES.SECURITY_STORAGE]:
							consent.security_storage === "granted",
						[CONSENT_TYPES.AD_PERSONALIZATION]:
							consent.ad_personalization === "granted",
						[CONSENT_TYPES.AD_USER_DATA]:
							consent.ad_user_data === "granted",
					},
				}),
			);
		}
	};

	// ############################################################

	return {
		CONSENT_TYPES: consentService.CONSENT_TYPES,
		consentValue,
		getConsentValue: consentService.getConsentValue,
		getStoredCustomSettings: consentService.getStoredCustomSettings,
		grantFullConsent,
		grantNecessaryConsent,
		grantCustomConsent,
		initializeConsent,
	};
};

// ############################################################
